import { PathBase } from "@constellation-academy/epic-ui/path/path-base";
import { z } from "zod";
import { ActivatePath, LoginPath, SignUpPath } from "@router/paths";

export const LOCAL_STORAGE_LOGIN_DATA_KEY = "tkt-login-data";
export const LOCAL_STORAGE_USER_DATA_KEY = "tkt-user-data";
export const DISALLOWED_REDIRECT_PATHS: PathBase[] = [
	new LoginPath(),
	new SignUpPath(),
	new ActivatePath(),
];

export const JwtTokenDataSchema = z.object({
	accessToken: z.string(),
	refreshToken: z.string(),
});

export const UserDataSchema = z.object({
	isAvgsClient: z.boolean().optional(),
	redirectPath: z.string().optional(),
});
